import { computed, Injectable, signal } from "@angular/core";
import { StockStateModel } from "../Dto/StockStateModel";
import { PaginationInfo, StockSummaryItem, StockSummaryTotals } from "../Dto/StockSummaryResponse";
import { StockSummaryRequest } from "../Dto/StockSummaryRequest";
import { sortByMaterialSequence } from "../../../Common/Utility/UtilityMaterialSequence";

const initialState: StockStateModel = {
  data: [],
  totals: {
    totalOnHand: 0,
    totalReserved: 0,
    totalAvailable: 0,
  },
  pagination: {
    page: 1,
    limit: 12,
    total: 0,
    pages: 0,
  },
  searchParams: {
    page: 1,
    limit: 12,
  },
  loading: false,
  error: null,
};

@Injectable({ providedIn: "root" })
export class StockState {
  private readonly state = signal<StockStateModel>(initialState);

  public readonly data = computed(() => this.state().data);
  public readonly totals = computed(() => this.state().totals);
  public readonly pagination = computed(() => this.state().pagination);
  public readonly searchParams = computed(() => this.state().searchParams);
  public readonly loading = computed(() => this.state().loading);
  public readonly error = computed(() => this.state().error);

  setSummary(data: StockSummaryItem[], totals: StockSummaryTotals, pagination: PaginationInfo): void {
    this.state.update((state) => ({
      ...state,
      data: sortByMaterialSequence(data, (item) => item.material ?? {}),
      totals,
      pagination,
      loading: false,
      error: null,
    }));
  }

  setSearchParams(params: StockSummaryRequest): void {
    this.state.update((state) => ({ ...state, searchParams: params }));
  }

  setLoading(loading: boolean): void {
    this.state.update((state) => ({ ...state, loading }));
  }

  setError(error: string | null): void {
    this.state.update((state) => ({ ...state, error }));
  }
}
